"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cmsDataCache_1 = __importDefault(require("../common/cmsDataCache"));
var cmsStaticDataProvider_1 = __importDefault(require("./cmsStaticDataProvider"));
var CmsDynamicDataProvider = /** @class */ (function () {
    function CmsDynamicDataProvider() {
    }
    CmsDynamicDataProvider.prototype.fetchWithTimeout = function (resource, options, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            var controller, id, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        controller = new AbortController();
                        id = setTimeout(function () { return controller.abort(); }, timeout);
                        options.signal = controller.signal;
                        return [4 /*yield*/, fetch(resource, options)];
                    case 1:
                        response = _a.sent();
                        clearTimeout(id);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CmsDynamicDataProvider.prototype._getData = function (query, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            var options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {};
                        if (CmsDynamicDataProvider.beforeLoadingData)
                            CmsDynamicDataProvider.beforeLoadingData(options);
                        if (this._preload)
                            this._preload(options);
                        if (!(timeout && timeout > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchWithTimeout(cmsDataCache_1.default.cmsDynamicDataLocation + query, options, timeout)];
                    case 1: return [4 /*yield*/, (_a.sent()).json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [4 /*yield*/, fetch(cmsDataCache_1.default.cmsDynamicDataLocation + query, options)];
                    case 4: return [4 /*yield*/, (_a.sent()).json()];
                    case 5: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CmsDynamicDataProvider.prototype._getDataSync = function (query) {
        var request = new XMLHttpRequest();
        request.open('GET', cmsDataCache_1.default.cmsDynamicDataLocation + query, false);
        if (CmsDynamicDataProvider.beforeLoadingData)
            CmsDynamicDataProvider.beforeLoadingData(request);
        if (this._preload)
            this._preload(request);
        request.send(null);
        if (request.status === 200) {
            return JSON.parse(request.responseText);
        }
    };
    CmsDynamicDataProvider.prototype.getSingleAsset = function (assetId, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            var data, ex_1, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 6]);
                        return [4 /*yield*/, this._getData('&fl=id,custom_t_json:%5Bjson%5D&q=id:' + assetId, timeout)];
                    case 1:
                        data = _a.sent();
                        cmsDataCache_1.default.set(assetId, data && data.response && data.response.docs && data.response.docs.length > 0
                            ? data.response.docs[0].custom_t_json
                            : {});
                        return [2 /*return*/, data && data.response && data.response.docs && data.response.docs.length > 0
                                ? data.response.docs[0].custom_t_json
                                : {}];
                    case 2:
                        ex_1 = _a.sent();
                        if (!(ex_1.name && ex_1.name === "AbortError" && cmsDataCache_1.default.cmsStaticDataLocation)) return [3 /*break*/, 4];
                        return [4 /*yield*/, new cmsStaticDataProvider_1.default().getSingleAsset(assetId, timeout)];
                    case 3:
                        data = _a.sent();
                        console.warn("Fall back from dynamic to static data for asset " + assetId);
                        return [2 /*return*/, data];
                    case 4: throw ex_1;
                    case 5: return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CmsDynamicDataProvider.prototype.getSingleAssetSync = function (assetId) {
        var data = this._getDataSync('&fl=id,custom_t_json:%5Bjson%5D&q=id:' + assetId);
        cmsDataCache_1.default.set(assetId, data && data.response && data.response.docs && data.response.docs.length > 0
            ? data.response.docs[0].custom_t_json
            : {});
        return data && data.response && data.response.docs && data.response.docs.length > 0
            ? data.response.docs[0].custom_t_json
            : {};
    };
    CmsDynamicDataProvider.prototype.getDynamicQuery = function (query, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getData('&' + query, timeout)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CmsDynamicDataProvider.prototype.getDynamicQuerySync = function (query) {
        return this._getDataSync('&' + query);
    };
    CmsDynamicDataProvider.prototype.setPreLoad = function (fn) {
        this._preload = fn;
    };
    return CmsDynamicDataProvider;
}());
exports.default = CmsDynamicDataProvider;
